import {useEffect, useState} from 'react'

import cn from 'clsx'

import { getValueWithCurrency } from '@App/helpers/toCurrency'
import { MarketIcon } from '@App/ui/crypto_exchange/desktop/components/common/MarketIcon'
import { TradeInfoModal } from '@App/ui/crypto_exchange/desktop/components/modals/TradeInfoModal'

import { Select } from '../../../../../SpotOrderTrade/components/Select'
import {
  formatDateFromApi,
  formatTimeFromApi,
  getTimestampFromPeriod,
  ReportsFilter
} from '../../../../model'
import { TradeInfo } from '../../../TradeInfo'
import { Card } from '../Card'

import s from './styles.module.scss'
import {useAppSelector} from "@App/hooks";
import {overallAnalytics, topTradesAnalytics} from "@Redux/slices/reports/selectors";
import {
  AnalyticsTrade,
  asyncGetOverallAnalytics,
  asyncGetTopTradesAnalytics,
  MiniTrade
} from "@Redux/slices/reports/ReportsSlice";
import {currentWallet} from "@Redux/slices/user/selectors";
import {useDispatch} from "react-redux";

enum Result {
  Profit = 'Profit',
  Loss = 'Loss',
}
const options = [
  { name: Result.Profit, value: Result.Profit },
  { name: Result.Loss, value: Result.Loss },
]

export const TopTrades = ({ filters }: {filters: ReportsFilter}) => {
  const [selectedTrade, setSelectedTrade] = useState<AnalyticsTrade | null>(null)
  const [tradeResult, setTradeResult] = useState(Result.Profit)
  const wallet = useAppSelector(currentWallet)
  const dispatch = useDispatch()
  const timestampFrom = getTimestampFromPeriod(filters.period)

  const args = {
    timestampInterval: {
      timestampFrom: timestampFrom,
      timestampTo:   null
    },
    profitable: tradeResult === Result.Profit
  }

  useEffect(() => {
    if (!wallet?.id) return
    dispatch(asyncGetTopTradesAnalytics(args))
  }, [wallet?.id, filters.period, tradeResult])

  const trades = useAppSelector(topTradesAnalytics)

  return (
    <Card
      className={s.container}
      title="Top Trades"
      contentClassName={s.content}
      headerRightElement={
        <Select
          value={tradeResult}
          options={options}
          containerClassName={s.selectContainer}
          inputClassName={s.select}
          optionClassName={s.option}
          onChange={(val) => setTradeResult(val as Result)}
        />
      }
    >
      <div className={s.header}>
        <div className={s.segment}>Market</div>
        <div className={cn(s.segment, s.end)}>Profit & Loss</div>
      </div>
      <div className={s.trades}>
        {trades.map((trade) => (
          <div key={trade.id} className={s.trade} onClick={() => setSelectedTrade(trade)}>
            <div className={cn(s.segment, s.left)}>
              <MarketIcon
                className={s.icon}
                symbol={trade.market.symbol}
              />
              <div className={s.content}>
                <div className={s.name}>
                  {trade.market.title}
                </div>
                <div className={s.date}>
                  {formatDateFromApi(trade.close_time as string)} {formatTimeFromApi(trade.close_time as string)}
                </div>
              </div>
            </div>
            <div className={cn(s.segment, s.right, trade.result <= 0 && s.negative)}>
              {getValueWithCurrency(trade.market.target_instrument_code, trade.result)}
            </div>
          </div>
        ))}
      </div>
      {!!selectedTrade && (
        <TradeInfoModal
          isOpen={!!selectedTrade}
          setIsOpen={() => setSelectedTrade(null)}
          headerContent={`Trade ${selectedTrade.status}`}
        >
          <TradeInfo trade={selectedTrade as any as MiniTrade} market={selectedTrade.market} />
        </TradeInfoModal>
      )}
    </Card>
  )
}
